import { Tooltip } from "@mui/material";
import styles from "./m3.module.css";

/**
 * Round M3 icon button.
 * Default style is tonal (filled primary container background with on-primary-container icon).
 *
 * @param {"tonal"|"standard"|"filled"} variant - "tonal" (standard filled primary container) or "standard" (transparent)
 * @param {"sm"|"md"} size
 */
const M3IconButton = ({
  icon,
  label,
  tooltip,
  onClick,
  disabled = false,
  size = "md",
  variant = "tonal",
  danger = false,
  className = "",
  style,
  ...props
}) => {
  const tipText = label || tooltip;
  const variantClass = danger
    ? styles.iconBtnDanger
    : variant === "standard"
    ? styles.iconBtnStandard
    : variant === "outlined"
    ? styles.iconBtnOutlined
    : variant === "filled"
    ? styles.filled
    : "";

  const buttonEl = (
    <button
      type="button"
      className={`${styles.iconBtn} ${variantClass} ${size === "sm" ? styles.iconBtnSm : ""} ${danger ? styles.iconBtnDanger : ""} ${className}`}
      onClick={onClick}
      disabled={disabled}
      aria-label={tipText}
      style={style}
      {...props}
    >
      {icon}
    </button>
  );

  if (!tipText) {
    return <span style={{ display: "inline-flex" }}>{buttonEl}</span>;
  }

  return (
    <Tooltip title={tipText} arrow placement="top">
      <span style={{ display: "inline-flex" }}>
        {buttonEl}
      </span>
    </Tooltip>
  );
};

export default M3IconButton;
